import { useSyncExternalStore } from 'react'
import { CollectionState } from '../collection-state'

export function useLocked (state: CollectionState) {
  return useSyncExternalStore(
    callback => state.addEventListener('lockedChanged', callback),
    () => state.locked
  )
}
